import gql from 'graphql-tag';

export const CancellationPolicyQuery = gql`
    query cancellationPolicyQuery(
        $arrivalDate: String!
        $isIpmNonGuaranteedPricing: Boolean!
        $unitUrl: String!
    ) {
        houseRules(
            arrivalDate: $arrivalDate
            isIpmNonGuaranteedPricing: $isIpmNonGuaranteedPricing
            unitUrl: $unitUrl
        ) {
            lodgingCancellationPolicy {
                cancellationPolicyPeriods {
                    label
                }
                nonRefundableFeeLabel
                policyType
            }
        }
    }
`;
